import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { NewSearchPopupLocations } from './NewSearchPopupLocations';
import { getRegions } from '../../../api/queries';
import { useUndoFilters } from '../../../hooks/useUndoFilters';
import { NewSearchLocationsProps } from './types';
import { selectSearchFormCurrentCity } from '../../../store/selectors';
import { RegionsQueryVariables } from '../../../graphql/graphql';

export const NewSearchLocations = ({
  formValues,
  modalParams,
  isInitialScreen,
  openCitiesHandler = () => {},
  locationsPopupIsOpen,
  setLocationsIsLoading,
  toggleHandlerLocations,
  renderSubmitText
}: NewSearchLocationsProps) => {
  const { t } = useTranslation();
  const undoFilters = useUndoFilters();
  const storedCity = useSelector(selectSearchFormCurrentCity);

  const cityId = formValues.city_id || storedCity;

  const locationsQueryVariables = { cityId } as RegionsQueryVariables;
  const { data: res } = useQuery(getRegions, {
    variables: locationsQueryVariables
  });

  const handleUndo = useCallback(() => {
    if (!isInitialScreen) {
      return;
    }
    undoFilters();
  }, [isInitialScreen]);

  const hasLocations = !!res?.regions?.length;
  const titleAndPlaceholderForLocationsModal = t(
    'search.locations_search.locations_placeholder.all_groups'
  );

  return (
    <NewSearchPopupLocations
      undo={handleUndo}
      isOpen={locationsPopupIsOpen}
      closeHandler={toggleHandlerLocations}
      inputPlaceholder={titleAndPlaceholderForLocationsModal}
      popupTitle={titleAndPlaceholderForLocationsModal}
      cityId={cityId}
      openCitiesHandler={openCitiesHandler}
      setLocationsIsLoading={setLocationsIsLoading}
      hasLocations={hasLocations}
      modalParams={modalParams}
      renderSubmitText={renderSubmitText}
    />
  );
};
